import { render, staticRenderFns } from "./approvals.vue?vue&type=template&id=32bbbd1c&"
import script from "./approvals.vue?vue&type=script&lang=js&"
export * from "./approvals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports